// extracted by mini-css-extract-plugin
export default {"root":"app_root__GMdji","rate18Alert":"app_rate18Alert__X59D2","show":"app_show__Xj31J","rate18AlertBG":"app_rate18AlertBG__dO+LO"};